import { render, staticRenderFns } from "./TestimonialManagerPopUp.vue?vue&type=template&id=a07c377a&scoped=true&"
import script from "./TestimonialManagerPopUp.vue?vue&type=script&lang=js&"
export * from "./TestimonialManagerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialManagerPopUp.vue?vue&type=style&index=0&id=a07c377a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07c377a",
  null
  
)

export default component.exports